export enum EventLocationType {
  Physical = 1,
  Virtual = 2,
  Predefined = 3,
}
